import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format.pipe';
import { ConfigService } from 'src/app/services/config/config.service';
import { ResponsibleGamingService } from 'src/app/services/responsible-gaming-service/responsible-gaming.service';

@Component({
  selector: 'app-limit-confirmation',
  templateUrl: './limit-confirmation.component.html',
  styleUrls: ['./limit-confirmation.component.scss'],
})
export class LimitConfirmationComponent implements OnInit {
  //@ViewChild('scrollableContent', {}) scrollableContent: ElementRef;
  //private scrollContainer: any;

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error = null;
  allPendingLimitData = [];
  toggleButtonText: any = {};
  depositLimitConfirmation:any = {};
  depositLimitReject:any = {};
  timeLimitConfirmation:any = {};
  timeLimitReject:any = {};
  spendLimitConfirmation: any = {};
  spendLimitReject: any = {};
  singleBetLimitConfirmation:any = {};
  singleBetLimitReject:any = {};
  lossLimitConfirmation:any = {};
  lossLimitReject:any = {};
  @Input() callBackFn: () => void;
  @Input() data: any;
  

  constructor(
    private responsibleGamingProvider: ResponsibleGamingService,
    public dateFormatPipe: DateFormatPipe,
    public config: ConfigService,
    private navigator:Navigator,
  ) { }

  ngOnInit() {
    if (!this.data || !this.data.length) {
      this.responsibleGamingProvider.getAllPendingLimit().subscribe({
        next: (response: any) => {
            if (response && !!response.result) {
                console.log(response.payload);
                this.allPendingLimitData = response.payload;
            }
        },
        error: (error) => {
            this.error = error;
        }
      });
    } else {
      this.allPendingLimitData = this.data;
    }
  }

  confirmOnlyDepositLimit(data, limitType, index){
    console.log('confirmOnlyDepositLimit', data, index);
    const depositLimitObj: any = {};
    depositLimitObj.termType = data;
    depositLimitObj.userSelection = true;

      this.responsibleGamingProvider.confirmDepositLimit(depositLimitObj).subscribe({
        next: (response: any) => {
            if (response && !!response.result) {
                  this.toggleDisplayText(index, 'confirm', limitType);
            }
        },
        error: (error) => {
            this.error = error;
        }
    });
  }

  rejectOnlyDepositLimit(data, limitType, index){
    console.log('rejectOnlyDepositLimit', data, index);
    const depositLimitObj: any = {};
    depositLimitObj.termType = data;
    depositLimitObj.userSelection = false;

    this.responsibleGamingProvider.confirmDepositLimit(depositLimitObj).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          this.toggleDisplayText(index, 'reject', limitType);
        }
      },
      error: (error) => {
        this.error = error;
      }
    });
  }

  confirmLimitExcludeDeposit(data, limitType, index){
    console.log('confirmLimitExcludeDeposit', data, limitType, index);
    const allLimitExceptdepositObj: any = {};
    allLimitExceptdepositObj.customerLimitID = data;
    allLimitExceptdepositObj.userSelection = true;

    this.responsibleGamingProvider.confirmAllExceptDepositLimit(allLimitExceptdepositObj).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          if (limitType == 'time') {
            this.toggleDisplayText(index, 'confirm', limitType);
          } else if (limitType == 'spend') {
            this.toggleDisplayText(index, 'confirm', limitType);
          } else if (limitType == 'single_bet') {
            this.toggleDisplayText(index, 'confirm', limitType);
          } else if (limitType == 'loss') {
            this.toggleDisplayText(index, 'confirm', limitType);
          } else {
            console.log('No matching limit type found for', limitType);
          }
        }
      },
      error: (error) => {
        this.error = error;
      }
    });
  }

  rejectLimitExcludeDeposit(data, limitType, index){
    console.log('rejectLimitExcludeDeposit', data, limitType, index);
    const allLimitExceptdepositObj: any = {};
    allLimitExceptdepositObj.customerLimitID = data;
    allLimitExceptdepositObj.userSelection = false;

    this.responsibleGamingProvider.confirmAllExceptDepositLimit(allLimitExceptdepositObj).subscribe({
      next: (response: any) => {
        if (response && !!response.result) {
          if (limitType == 'time') {
            this.toggleDisplayText(index, 'reject', limitType);
          } else if (limitType == 'spend') {
            this.toggleDisplayText(index, 'reject', limitType);
          } else if (limitType == 'single_bet') {
            this.toggleDisplayText(index, 'reject', limitType);
          } else if (limitType == 'loss') {
            this.toggleDisplayText(index, 'reject', limitType);
          } else {
            console.log('No matching limit type found for', limitType);
          }
        }
      },
      error: (error) => {
        this.error = error;
      }
    });
  }

  toggleDisplayText(i, action?, limitType?){
    console.log(i);
    this.toggleButtonText[i] = !this.toggleButtonText[i];
    if(action == 'reject'){
      if (limitType == 'time') {
        this.timeLimitReject[i] = !this.timeLimitReject[i];
      } else if (limitType == 'spend') {
        this.spendLimitReject[i] = !this.spendLimitReject[i];
      } else if (limitType == 'single_bet') {
        this.singleBetLimitReject[i] = !this.singleBetLimitReject[i];
      } else if (limitType == 'loss') {
        this.lossLimitReject[i] = !this.lossLimitReject[i];
      } else if (limitType == 'deposit_limit') {
        this.depositLimitReject[i] = !this.depositLimitReject[i];
      } else {
        console.log('No matching limit type found for toggleDisplayText', limitType);
      }
    } else {
      if (limitType == 'time') {
        this.timeLimitConfirmation[i] = !this.timeLimitConfirmation[i];
      } else if (limitType == 'spend') {
        this.spendLimitConfirmation[i] = !this.spendLimitConfirmation[i];
      } else if (limitType == 'single_bet') {
        this.singleBetLimitConfirmation[i] = !this.singleBetLimitConfirmation[i];
      } else if (limitType == 'loss') {
        this.lossLimitConfirmation[i] = !this.lossLimitConfirmation[i];
      } else if (limitType == 'deposit_limit') {
        this.depositLimitConfirmation[i] = !this.depositLimitConfirmation[i];
      } else {
        console.log('No matching limit type found for toggleDisplayText', limitType);
      }
    }
  }
  closeModal = () => {
    this.navigator.dismiss();
    if (this.callBackFn) {
      this.callBackFn();
    }
  }
}
